import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {TableRow} from 'platform/components';
import {Icon} from 'platform/foundation';

import {GetDirectSaleVariantDefaultVarehousesPriorityResponse} from '@dms/api/warehouse';

import {TableCell} from './TableCell';

type WarehouseItem = GetDirectSaleVariantDefaultVarehousesPriorityResponse[0];

export interface SortableWarehouseRowProps {
  warehouse: WarehouseItem;
  index: number;
}

export function SortableWarehouseRow(props: SortableWarehouseRowProps) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.warehouse.warehouseId,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <TableRow {...attributes} data-testid={`warehouse-row-${props.index}`}>
      <div ref={setNodeRef} style={style}>
        <div
          {...listeners}
          style={{
            cursor: 'grab',
            padding: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          data-testid={`drag-handle-${props.index}`}
        >
          <Icon value="action/drag_indicator" size={4} />
        </div>
      </div>

      <TableCell value={props.warehouse.warehousePriority} />
      <TableCell value={props.warehouse.warehouseName} />
      <TableCell value={props.warehouse.warehouseNumber} />
      <TableCell value={props.warehouse.authorizationProfile?.name} />
      <TableCell value={props.warehouse.branch?.name} />
    </TableRow>
  );
}
